module.exports = __webpack_public_path__ + "static/media/17.725c7ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/17.png
// module id = 1122
// module chunks = 0